import * as React from 'react'
import { useMemo, useState } from 'react'

import { Autocomplete, Box, TableContainer, TextField } from '@mui/material'
import PageSection from '../../../Constants&Theme/PageSection'
import { useScreenReportCols } from './ScreenReportCols'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { appBar } from '../../../garvan-react/Constants/StyleConstants'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { useGetScreenReportResults } from '../../../APIs/Hooks/ScreenHooks'
import ScreenReportDGToolbar, { ScreenFilters } from './ScreenReportDGToolbar'

function ScreenReport({ manifest }: { manifest: boolean }) {
  const [reportIDs, setReportIDs] = useState<any[]>([])
  const [dgFilters, setDGFilters] = useState<Partial<ScreenFilters>>({})
  const cols = useScreenReportCols(manifest)

  const resultQueries = useGetScreenReportResults(
    manifest,
    [...new Set(reportIDs)],
    setReportIDs,
  )

  const combinedResults = useMemo(() => {
    let results: any[] = []
    resultQueries
      .filter((q) => q.data?.samples) //have data
      .forEach((q) => {
        results = results.concat(Object.values(q.data.samples))
      })
    return results
      .filter(
        (s) =>
          !dgFilters?.FacilityID ||
          s?.DestinationFacilityID === dgFilters?.FacilityID,
      )
      .filter((s) => !dgFilters?.StatusID || s?.Status === dgFilters?.StatusID)
  }, [resultQueries, dgFilters])
  return (
    <Box
      sx={{
        maxWidth: 'xl',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={`Screen ${manifest ? 'Manifest' : ''} Report`}>
        <Autocomplete
          fullWidth
          sx={{ mb: stackGap.col }}
          multiple
          renderInput={(params) => (
            <TextField
              {...params}
              label={`${manifest ? 'Vessel' : 'Screen'} IDs`}
              placeholder={`Scan ${manifest ? 'vessel' : 'screen'} IDs`}
            />
          )}
          onChange={async (event, newValue) => {
            setReportIDs(newValue)
            setDGFilters({})
          }}
          options={[]}
          freeSolo
          value={reportIDs}
        />
        <TableContainer
          sx={{ height: `calc(100vh - ${appBar}px - 300px)`, width: 1 }}
        >
          <DataGridPro
            getRowId={(row) => row.SampleID}
            rows={combinedResults}
            columns={cols}
            disableRowSelectionOnClick
            loading={resultQueries.some((q) => q.isLoading)}
            disableColumnMenu
            slots={{
              toolbar: ScreenReportDGToolbar as any,
            }}
            slotProps={{
              toolbar: {
                dgFilters,
                setDGFilters,
                manifest,
              },
            }}
          />
        </TableContainer>
      </PageSection>
    </Box>
  )
}

export default ScreenReport
